const actions = {
    FETCH_DEVICE_VERSION: 'FETCH_DEVICE_VERSION',
    fetchDeviceVersion: (payload) => {
        return {
            type: actions.FETCH_DEVICE_VERSION,
            payload,
        };
    },
};
export default actions;
